import _styled from "@emotion/styled-base";
import { Box } from "../";

var Card = /*#__PURE__*/_styled(Box, {
  target: "e19a0egr0",
  label: "Card"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmQvQ2FyZC5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3dCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmQvQ2FyZC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCb3ggfSBmcm9tICcuLi8nO1xuXG5jb25zdCBDYXJkID0gc3R5bGVkKEJveClgYDtcblxuQ2FyZC5kZWZhdWx0UHJvcHMgPSB7XG4gIGJveFNoYWRvdzogJ2RlZmF1bHQnLFxuICBib3JkZXJSYWRpdXM6ICdkZWZhdWx0JyxcbiAgYmc6ICd3aGl0ZScsXG4gIHA6IDQsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBDYXJkO1xuIl19 */");

Card.defaultProps = {
  boxShadow: 'default',
  borderRadius: 'default',
  bg: 'white',
  p: 4
};
export default Card;